import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { getInitials } from '@boels/helpers';
import { BoelsUser } from '@boels/models';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faUser } from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'boels-account-indicator',
  imports: [FontAwesomeModule],
  templateUrl: './account-indicator.component.html',
  styleUrls: ['./account-indicator.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AccountIndicatorComponent {
  boelsUser = input.required<BoelsUser>();

  protected readonly faUser = faUser;

  getInitials(): string {
    const name = this.boelsUser().debtor?.name
      ? (this.boelsUser().debtor?.name as string)
      : ' ';
    return getInitials(name);
  }
}
